<template>
  <div class="app-slide" >
    <ul class="silde-wrap">
      <li v-if="slide.title" class="slide-header">{{slide.title}}</li>
      <li v-for="(it,index) in slide.children" :key="index" :style="{'background-color':$route.path == it.path ? '#545c64' : ''}"   class="slide-box" >
        <router-link :to="it.path" :class="{'slide-active':$route.path == it.path}" class="slide-item" >
          <p>{{it.title}}</p>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex'
export default {
  name: "AppSlide",
  computed: {
    ...mapState([ 'meau' ]),
    slide(){
      let obj = {};
      this.meau.forEach(ele => {
        ele.children.forEach(e => {
          if(this.$route.path.includes(e.path)){
            obj = e
          }
        })
      })
      return obj;
    }
  },
};
</script>

<style lang="less">
  .app-slide {
    width: 100%;
    height:100%;
    background: #fff;
    .silde-wrap {
      width: 100%;
      height: 100%;
      list-style: none;
      margin: 0;
      padding: 0;
      .slide-header {
        height: 60px;
        line-height: 60px;
        padding-left:15px ;
        box-sizing:border-box;
        font-size: 18px;
        border-bottom: 1px solid #ccc;
      }
      .slide-box {
        width: 100%;
        height: 45px;
        line-height: 45px;
        padding: 0 15px;
        box-sizing: border-box;
        .slide-item {
          display:block;
          width: 100%;
          text-decoration:none;
          color: #666;
          font-size: 16px;
          font-weight: 400;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #ccc;
          >p {
            flex: 1;
            height: 45px;
            line-height: 45px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          .slide-icon {
            font-size: 24px;
          }
        }
        .slide-active {
          background: #545c64;
          color: #ffd04b;
          border: none;
        }
      }
    }
  }
</style>